<div class="d-flex justify-content-center" id="waiting-spinner">
    <mat-spinner class="mt-5"></mat-spinner>
</div>
<div style="height: 100vh; width: 100vw; position: absolute; top: 0;">
    <iframe id="assetDivIdMob" width="100%"
        height="100%" frameborder="0" webkitallowfullscreen="" mozallowfullscreen="" allowfullscreen=""></iframe>

        <!-- <iframe id="assetDivIdMob"
            src='https://view.officeapps.live.com/op/embed.aspx?src=http%3A%2F%2Fieee802%2Eorg%3A80%2Fsecmail%2FdocIZSEwEqHFr%2Edoc'
            width='100%' height='100%' frameborder='0'>This is an embedded <a target='_blank' href='http://office.com'>Microsoft
                Office</a> document, powered by <a target='_blank' href='http://office.com/webapps'>Office Online</a>.</iframe> -->
</div>



<!-- <ngx-doc-viewer [url]="url" viewer="google" [googleCheckContentLoaded]="true" (loaded)="showLoading()" [googleCheckInterval]="1000" googleMaxChecks="5" style="width:100%;height:100vh;"></ngx-doc-viewer> -->




